'use strict';

const pdpSwatchList = (function() {
  const swatches = Array.from(document.querySelectorAll('.js-variant-swatch'));
  const variantName = document.getElementById('js-variant-name');
  let swatchTimer = {};
  let activeVariant = '';
  function toggleName() {
    let variant = this.getAttribute('data-variant');
    variantName.innerHTML = variant;
    clearTimeout(swatchTimer);
  }
  function startTimer() {
    swatchTimer = setTimeout(resetName, 250);
  }
  function resetName() {
    variantName.innerHTML = activeVariant;
  }
  function init() {
    activeVariant = swatches[0].getAttribute('data-variant');
    swatches.forEach(swatch => {
      swatch.addEventListener('mouseover', toggleName);
      swatch.addEventListener('mouseout', startTimer);
    });
  }
  window.addEventListener('DOMContentLoaded', () => {
    if (swatches.length) init();
  });
})();

export default pdpSwatchList;
